import React from "react";
import {CatalogService} from "../../../service/catalog/CatalogService";
import PresvalDropDown from "../PresvalDropDownView";


export default class SpecialFlowDropDownContainer extends React.Component {
    constructor(props) {
        super(props);
        this.catalogService = new CatalogService();

        this.geSpecialFlowCatalog = this.geSpecialFlowCatalog.bind(this);

        this.state = {
            catSpecialFlowCatalog: this.geSpecialFlowCatalog(),
        };
    }

    geSpecialFlowCatalog() {
        this.catalogService.geSpecialFlowCatalog().then(
            res => {
                this.setState({
                    catSpecialFlowCatalog: res,
                });
                this.props.loading(false);
            }
        )
    }

    render() {
        return <PresvalDropDown
            name={this.props.name}
            filter={this.props.filter}
            options={this.state.catSpecialFlowCatalog}
            save={this.props.save}
            value={this.props.value}
        />
    }
};